export const getTicketNotesImportFields = () => {
  const ticketNotesFields = [
    {
      label: 'attribute.ticket.referenceId',
      key: 'ticketSourceReferenceId',
      type: 'string',
      validators: [
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        }
      ]
    },
    // {
    //   label: 'attribute.ticketId',
    //   key: 'ticketId',
    //   type: 'string',
    //   validators: [
    //     {
    //       validate: 'required',
    //       errorMessage: 'dromo.validation.requiredField'
    //     }
    //   ]
    // },
    {
      label: 'attribute.content',
      key: 'content',
      type: 'string',
      validators: [
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        }
      ]
    },
    {
      label: 'attribute.privacyType',
      key: 'privacyType',
      type: 'select',
      validators: [
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        }
      ],
      selectOptions: [
        {
          label: 'asset.details.agent.status.private',
          value: 'Private'
        },
        {
          label: 'asset.details.agent.status.public',
          value: 'Public'
        }
      ]
    },
    {
      label: 'asset.details.agent.attachments',
      key: 'attachments',
      type: 'string'
    },
    {
      label: 'attribute.addedOn',
      key: 'addedOn',
      type: 'string',
      validators: [
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        },
        {
          validate: 'regex_match',
          regex:
            '^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?$',
          errorMessage: 'dromo.validation.dateTime'
        }
      ]
    },
    {
      label: 'attribute.addedBy',
      key: 'addedBy',
      type: 'string',
      validators: [
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        },
        {
          validate: 'regex_match',
          // prettier-ignore
          regex: '^([a-zA-Z0-9_+\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$',
          errorMessage: 'domain.validation.emailAddress'
        }
      ]
    }
  ];

  return ticketNotesFields;
};
